import { render } from "./DettaglioPrenotazionePage.vue?vue&type=template&id=2f0f4613&scoped=true"
import script from "./DettaglioPrenotazionePage.vue?vue&type=script&lang=js"
export * from "./DettaglioPrenotazionePage.vue?vue&type=script&lang=js"

import "./DettaglioPrenotazionePage.vue?vue&type=style&index=0&id=2f0f4613&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0f4613"]])

export default __exports__